export class Title {
  id: string;
  items: TitleItem[];
  schemaVersion: string;
  isDeleted: boolean;
  isValid: boolean;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
}

export class TitleItem {
  identifier: string;
}

export class TitleUpsert {
  items: TitleItem[];
  schemaVersion: string;
}
